/* eslint-disable react/display-name */
import clsx from "clsx";
import React, { InputHTMLAttributes, forwardRef } from "react";

type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & {
  checkedClassName?: string;
  className?: string;
};

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ checked, checkedClassName, className, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type="checkbox"
        {...props}
        checked={checked}
        className={clsx("tw-checkbox", className, checked && checkedClassName)}
      />
    );
  }
);
